module.exports = __webpack_public_path__ + "static/img/2.2ca1d1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/zh/2.png
// module id = 2ug9
// module chunks = 0